var map = {
	"./components/admin": [
		"./src/app/components/admin/admin.module.ts",
		"common",
		"components-admin"
	],
	"./components/pos": [
		"./src/app/components/pos/pos.module.ts",
		"common",
		"components-pos"
	],
	"src/app/components/admin/accountmanagement": [
		"./src/app/components/admin/accountmanagement/accountmanagement.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"common",
		"src-app-components-admin-accountmanagement"
	],
	"src/app/components/admin/configuration": [
		"./src/app/components/admin/configuration/configuration.module.ts",
		"src-app-components-admin-configuration"
	],
	"src/app/components/admin/configuration/discount": [
		"./src/app/components/admin/configuration/discount/discount.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"src-app-components-admin-configuration-discount"
	],
	"src/app/components/admin/configuration/floor": [
		"./src/app/components/admin/configuration/floor/floor.module.ts",
		"src-app-components-admin-configuration-floor"
	],
	"src/app/components/admin/configuration/system": [
		"./src/app/components/admin/configuration/system/system.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"src-app-components-admin-configuration-system"
	],
	"src/app/components/admin/configuration/table": [
		"./src/app/components/admin/configuration/table/table.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"src-app-components-admin-configuration-table"
	],
	"src/app/components/admin/productmanagement": [
		"./src/app/components/admin/productmanagement/productmanagement.module.ts",
		"src-app-components-admin-productmanagement"
	],
	"src/app/components/admin/productmanagement/category": [
		"./src/app/components/admin/productmanagement/category/category.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"default~src-app-components-admin-productmanagement-category~src-app-components-admin-productmanageme~9188b96b",
		"src-app-components-admin-productmanagement-category"
	],
	"src/app/components/admin/productmanagement/coupon": [
		"./src/app/components/admin/productmanagement/coupon/coupon.module.ts",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~b2d2baf1",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~3358337e",
		"src-app-components-admin-productmanagement-coupon"
	],
	"src/app/components/admin/productmanagement/currency": [
		"./src/app/components/admin/productmanagement/currency/currency.module.ts",
		"src-app-components-admin-productmanagement-currency"
	],
	"src/app/components/admin/productmanagement/group": [
		"./src/app/components/admin/productmanagement/group/group.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"default~src-app-components-admin-productmanagement-category~src-app-components-admin-productmanageme~9188b96b",
		"default~src-app-components-admin-productmanagement-group~src-app-components-admin-productmanagement-~0543407d",
		"src-app-components-admin-productmanagement-group"
	],
	"src/app/components/admin/productmanagement/item": [
		"./src/app/components/admin/productmanagement/item/item.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~b2d2baf1",
		"default~src-app-components-admin-productmanagement-category~src-app-components-admin-productmanageme~9188b96b",
		"default~src-app-components-admin-productmanagement-group~src-app-components-admin-productmanagement-~0543407d",
		"src-app-components-admin-productmanagement-item"
	],
	"src/app/components/admin/productmanagement/item-edit-history": [
		"./src/app/components/admin/productmanagement/item-edit-history/item-edit-history.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"default~src-app-components-admin-productmanagement-category~src-app-components-admin-productmanageme~9188b96b",
		"default~src-app-components-admin-productmanagement-group~src-app-components-admin-productmanagement-~0543407d",
		"src-app-components-admin-productmanagement-item-edit-history"
	],
	"src/app/components/admin/productmanagement/itemreport": [
		"./src/app/components/admin/productmanagement/itemreport/itemreport.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~b2d2baf1",
		"default~src-app-components-admin-productmanagement-category~src-app-components-admin-productmanageme~9188b96b",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~3358337e",
		"default~src-app-components-admin-productmanagement-itemreport~src-app-components-admin-report~src-ap~8c6d223a",
		"default~src-app-components-admin-productmanagement-group~src-app-components-admin-productmanagement-~0543407d",
		"default~src-app-components-admin-productmanagement-itemreport~src-app-components-admin-report",
		"src-app-components-admin-productmanagement-itemreport"
	],
	"src/app/components/admin/productmanagement/modifier": [
		"./src/app/components/admin/productmanagement/modifier/modifier.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"default~src-app-components-admin-productmanagement-category~src-app-components-admin-productmanageme~9188b96b",
		"src-app-components-admin-productmanagement-modifier"
	],
	"src/app/components/admin/productmanagement/tax": [
		"./src/app/components/admin/productmanagement/tax/tax.module.ts",
		"src-app-components-admin-productmanagement-tax"
	],
	"src/app/components/admin/productmanagement/unit": [
		"./src/app/components/admin/productmanagement/unit/unit.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-configuration-discount~src-app-components-admin-productmanagement-c~a1b35e07",
		"src-app-components-admin-productmanagement-unit"
	],
	"src/app/components/admin/report": [
		"./src/app/components/admin/report/report.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~b2d2baf1",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~3358337e",
		"default~src-app-components-admin-productmanagement-itemreport~src-app-components-admin-report~src-ap~8c6d223a",
		"default~src-app-components-admin-productmanagement-itemreport~src-app-components-admin-report"
	],
	"src/app/components/pos/kitchen": [
		"./src/app/components/pos/kitchen/kitchen.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~b2d2baf1",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~3358337e",
		"default~src-app-components-admin-productmanagement-itemreport~src-app-components-admin-report~src-ap~8c6d223a",
		"default~src-app-components-pos-kitchen~src-app-components-pos-order~src-app-components-pos-table",
		"default~src-app-components-pos-kitchen~src-app-components-pos-table",
		"common",
		"src-app-components-pos-kitchen"
	],
	"src/app/components/pos/order": [
		"./src/app/components/pos/order/order.module.ts",
		"default~src-app-components-pos-kitchen~src-app-components-pos-order~src-app-components-pos-table",
		"src-app-components-pos-order"
	],
	"src/app/components/pos/table": [
		"./src/app/components/pos/table/table.module.ts",
		"default~src-app-components-admin-accountmanagement~src-app-components-admin-configuration-discount~s~986f9110",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~b2d2baf1",
		"default~src-app-components-admin-productmanagement-coupon~src-app-components-admin-productmanagement~3358337e",
		"default~src-app-components-admin-productmanagement-itemreport~src-app-components-admin-report~src-ap~8c6d223a",
		"default~src-app-components-pos-kitchen~src-app-components-pos-order~src-app-components-pos-table",
		"default~src-app-components-pos-kitchen~src-app-components-pos-table",
		"src-app-components-pos-table"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;